<template>
  <div :class="$gStyle('mt-4')">
    <patternlib-headline :headline="deviceDescription" headingTag="h6" />
    <div :class="$gStyle('mt-4')">
      {{ t('spareparts.serialNumber', { serialnumber }) }}
    </div>
    <div>
      {{
        t('spareparts.deviceName', {
          devicename: externalProductName.length > 0 ? externalProductName : '-'
        })
      }}
    </div>

    <patternlib-link
      size="M"
      :label="t('spareparts.newSearch')"
      @click="newSearch()"
      icon-position="right"
      icon="circle-arrow-right"
      :class="$gStyle('mt-4')"
    >
    </patternlib-link>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { useDataStore } from '../stores/data';

  const store = useDataStore();
  const { serialnumber, deviceDescription, externalProductName } =
    storeToRefs(store);
  const { showSearchMask } = store;

  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';
  const { t } = useI18n();
  const router = useRouter();

  const newSearch = async () => {
    await router.replace({ hash: '', query: {} });
    showSearchMask();
  };
</script>

<style scoped></style>
